const UUID_REGEX = /^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/i;

export const isValidUuid = (value: string): boolean => UUID_REGEX.test(value);
